<script setup lang="ts">
import VFormSwitchInput from '@modules/forms/components/inputs/VFormSwitchInput/VFormSwitchInput.vue';
import { usePostbackChangeStatusMutation } from '@modules/postbacks/mutations';
import { useUserSupervision } from '@modules/user/composables';

import type { PostbackChangeActivitySwitchProps } from './types';

const props = defineProps<PostbackChangeActivitySwitchProps>();

const { isSupervision } = useUserSupervision();

const { mutateAsync, isLoading } = usePostbackChangeStatusMutation();

async function onChange(value?: boolean): Promise<void> {
  await mutateAsync({
    id: props.affiliateId,
    postbackId: props.item.id,
    active: !value,
  });
}
</script>

<template>
  <VFormSwitchInput v-data-qa-auto-id="'PostbackChangeActivitySwitch'"
    :value="item.active"
    hide-errors
    :disabled="item.build || isLoading || isSupervision"
    @change="onChange"
  />
</template>
